import { Link, useNavigate, useLocation } from 'react-router-dom';
import visaCardLogo from '../../../../assets/img/logo/visa-card-logo.png';
import brandLogo from '../../../../assets/img/logo/brand-crest.png';
import brandLogo2 from '../../../../assets/img/logo/brand-crest_dark.png';
import masterCardBgImg from '../../../../assets/img/logo/card_bg-cardplot.png';
import CardsProgressSteps from '../../../../components/ProgressStep/CardsProgressSteps';


const NewCard = ({ userDetails, setCards }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const storedCardDetails = location.state?.customizedCardDetails || {};
    // const storedCardDetails = JSON.parse(localStorage.getItem("customizedCardDetails"));    
    const cardDetails = {
        cardholderName: userDetails?.bank_account[0]?.account_name,
        nickname: storedCardDetails?.nickname,
        cardNumber: "0000 **** **** 0000",
        expiryDate: "00/00",
        cardLogo: storedCardDetails?.cardTypeLogo,
        backgroundColor: storedCardDetails?.cardTheme?.color,
        backgroundImage: storedCardDetails?.cardTheme?.bgImage,
    };

    const handleContinue = () => {
        setCards(true);
        navigate("/user/cards");
    }
    
  return (
    <section className='create__card__page new__card__page pt-4'>  
    
        {/* Progress steps removed from success screen */}
        
        <section className="create-card_section new__card__section pt-5">
            <div className="container py-5">

                <div className="card__new__details pt-5">
                    <div className="card__details__display pt-5">
                        <div className="d-flex justify-content-center pt-5">
                            {/* Shadow Cards */}
                            <div className="card__shadow card__shadow--one" style={{ backgroundColor: cardDetails?.backgroundColor, backgroundImage: `url(${cardDetails?.backgroundImage})` }}>
                                <div className="brand-bg-watermark" style={{ backgroundImage: `url(${cardDetails?.backgroundColor === '#F5F5F5' ? brandLogo2 : brandLogo})` }} ></div>
                            </div>
                            <div className="card__shadow card__shadow--two" style={{ backgroundColor: cardDetails?.backgroundColor, backgroundImage: `url(${cardDetails?.backgroundImage})` }}>
                                <div className="brand-bg-watermark" style={{ backgroundImage: `url(${cardDetails?.backgroundColor === '#F5F5F5' ? brandLogo2 : brandLogo})` }}></div>
                            </div>
                            <div className="card__shadow card__shadow--three" style={{ backgroundColor: cardDetails?.backgroundColor, backgroundImage: `url(${cardDetails?.backgroundImage})` }}>
                                <div className="brand-bg-watermark" style={{ backgroundImage: `url(${cardDetails?.backgroundColor === '#F5F5F5' ? brandLogo2 : brandLogo})` }}></div>
                            </div>
                            <div className={`card__details__preview ${cardDetails?.backgroundColor === '#F5F5F5' && 'dark-logo'}`}
                                style={{
                                    backgroundColor: cardDetails?.backgroundColor,
                                    backgroundImage: `url(${cardDetails?.backgroundImage})`
                                }}>
                                    <div className="card__left__details">
                                        <h4>{cardDetails?.nickname}</h4>

                                        <div className="">
                                            <h5>{cardDetails?.cardholderName}</h5>
                                            <h6 className="mt-1">{cardDetails?.cardNumber}</h6>
                                        </div>
                                    </div>
                                    <div className="card__right__details">
                                        <img src={cardDetails?.backgroundColor === '#F5F5F5' ? brandLogo2 : brandLogo} alt="Card Logo" width="" height='' />
                                        {/* <img src={brandLogo} alt="Card Logo" width="41.59px" height='35px' /> */}
                                        <div className="">
                                            <span className='d-flex justify-content-end' style={{ fontSize: '7px' }}>debit</span>
                                            <img src={cardDetails?.cardLogo} alt="Card Type" className='img-fluid' />
                                        </div>
                                    </div>
                            </div>

                        </div>
                    </div>
                    <h3 className='text-center my-4'>Card created successfully</h3>

                    <div className="d-flex align-items-center justify-content-center mt-5">
                        <button onClick={handleContinue} className="btn primary__btn__outline">
                            View Cards
                        </button>
                    </div>
                </div>
            </div>
        </section>
    </section>
  )
}

export default NewCard